import React, { useRef, useState } from 'react';
import { TextField, Typography, InputAdornment, Checkbox, withStyles, Snackbar, Radio } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import search from '../../assets/ic_date.png';
import bg_notif from '../../assets/bg_notif.png';
import ic_edit from '../../assets/1@3x.png';
import ic_search from '../../assets/ic_search.png';
import circle from '../../assets/circle.png';
import print from '../../assets/ic_print.png';
import Loader from 'react-loader-spinner'
import ic_checkmark from '../../assets/ic_checkmark.png';
import line from '../../assets/line grey.png';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import ImageUploader from 'react-images-upload';
import api from '../api';
import { useHistory, useLocation } from 'react-router-dom';
import { ComponentToPrint } from './ComponentToPrint';
import { format } from 'date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import ErrorRequest from '../ErrorRequest';
import { green } from '@material-ui/core/colors';
import UploadFile from "../components/UploadMultipleFile";
import ic_error from '../../assets/ic_exclamation.png';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import Constant from '../../library/Constant';
import { ComponentGC } from './ComponentGC';

const pageStyle = `{size: 3.075in 10.25in}`;

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5,
        borderRadius: 20,
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

export default function DetailHistoryReservasi(props) {
    const componentRef = useRef()
    const history = useHistory()
    const location = useLocation()
    const componentToPrint = useRef()
    const componentGC = useRef()
    const tempData = location.state.data
    const doctor_schedule_id = location.state.emergency.doctor_schedule_detail_id
    const doctor_schedule_detail_id = location.state.emergency.doctor_schedule_id
    const id = location.state.id
    const is_emergency = location.state.is_emergency
    // console.log(is_emergency === null);
    // console.log(data);
    const dateAndTime = new Date(tempData.appointment_date)
    const a = dateAndTime.getDate()
    let b = dateAndTime.getMonth() + 1
    const c = dateAndTime.getFullYear()
    // console.log(b);
    switch (b) {
        case 1:
            b = "Jan"
            break;
        case 2:
            b = "Feb"
            break;
        case 3:
            b = "Mar"
            break;
        case 4:
            b = "Apr"
            break;
        case 5:
            b = "Mei"
            break;
        case 6:
            b = "Jun"
            break;
        case 7:
            b = "Jul"
            break;
        case 8:
            b = "Aug"
            break;
        case 9:
            b = "Sep"
            break;
        case 10:
            b = "Oct"
            break;
        case 11:
            b = "Nov"
            break;
        default:
            b = "Des"
            break;
    }
    const displayDate = `${a} ${b} ${c}, ${tempData.time_start.slice(0, 5)} - ${tempData.time_end.slice(0, 5)}`
    let defaultValue = null
    const dispatch = useDispatch();
    const [noSEP, setNoSEP] = React.useState("")
    const [uploadVisible, setUploadVisible] = useState(false)
    const [error, setError] = useState(false)
    const [errorForce, setErrorForce] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [pictures, setPicture] = useState([])
    const [status, setStatus] = React.useState(false)
    const [dataPoli, setDataPoli] = React.useState([])
    const [data, setData] = React.useState(tempData)
    const [visibleListPoli, setVisibleSetListPoli] = React.useState(false)
    const [loading, setLoading] = React.useState(false);
    const [visibleEmergency, setVisibleEmergency] = React.useState(false);
    const [visibleBatal, setVisibleBatal] = React.useState(false);
    const [visibleEdit, setVisibleEdit] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [messageAlertStatus, setMessageAlertStatus] = React.useState("")
    const [statusAlertStatus, setStatusAlertStatus] = React.useState("")
    const [openAlertStatus, setOpenAlertStatus] = React.useState(false);
    const [tanggal, setTanggal] = React.useState(tempData.appointment_date);
    const [room, setRoom] = React.useState(null)
    const [alasanBatal, setAlasanBatal] = React.useState(null)
    const [idDokter, setIdDokter] = React.useState(null);
    const [selectedId, setSelectedId] = React.useState(null);
    const [timeId, setTimeId] = React.useState(null);
    const [slotWaktu, setSlotWaktu] = React.useState([]);
    const [timeslot, setTimeslot] = React.useState([]);
    const [timeValue, setTimeValue] = React.useState(null);
    // const [timeslowt, setTimeslot] = React.useState([]);
    const [pasienSchedule, setPasienSchedule] = React.useState(tempData.patient_schedule);
    const [paymentMethod, setPaymentMethod] = React.useState(tempData.payment_option_name);
    const [visibleCheckIn, setVisibleCheckIn] = React.useState(false);
    const [visibleCheckInReservation, setVisibleCheckInReservation] = React.useState(false);
    const [visibleNomorAntrian, setVisibleNomorAntrian] = useState(false)
    const [errorRequest, setErrorRequest] = React.useState(false);
    const [errorMessageRequest, setErrorMessageRequest] = React.useState(false);
    const [visibleCatatanPetugas, setVisibleCatatanPetugas] = React.useState(false);
    const [expand, setExpand] = React.useState(false);
    const [catatanPetugas, setCatatanPetugas] = React.useState(null);
    const [visibleJadwal, setVisibleJadwal] = React.useState(false);
    const [visibleNotes, setVisibleNotes] = React.useState(false);
    const [detailDokter, setDetailDokter] = React.useState(null);
    const [disableButton, setDisableButton] = React.useState(false)
    const [disableCheckin, setDisableCheckin] = React.useState(false)
    const [noRujukan, setNoRujukan] = React.useState("")
    const [dateRujukan, setDateRujukan] = React.useState(null)
    const [namaPasienBPJS, setNamaPasienBPJS] = React.useState("")
    const [namaPasienAsuransi, setNamaPasienAsuransi] = React.useState("")
    const [noKartuBPJS, setNoKartuBPJS] = React.useState("")
    const [noKartuAsuransi, setNoKartuAsuransi] = React.useState("")
    const [errorRujukan, setErrorRujukan] = React.useState(false)
    const [textErrorRujukan, setTextErrorRujukan] = React.useState("")
    const [listProvider, setListProvider] = React.useState([])
    const [provider, setProvider] = React.useState(null)
    const [pickAsuransi, setPickAsuransi] = React.useState(null)
    const [arrayAsuransi, setArrayAsuransi] = React.useState([])
    const [visibleOpenPendukung, setVisibleOpenPendukung] = React.useState(false)
    const [categoryProvider, setCategoryProvider] = React.useState([])
    const [pickCategory, setPickCategory] = React.useState(null)
    const [fileUpload, setFileUpload] = React.useState([])
    const [categoryDetail, setCategoryDetail] = React.useState("-");
    const [visibleForceCheckin, setVisibleForceCheckin] = useState(false)
    const [errorMessageRequestCheckin, setErrorMessageRequestCheckin] = useState("")
    const [visibleForceCheckinRegis, setVisibleForceCheckinRegis] = useState(false)
    const [errorMessageRequestCheckinRegis, setErrorMessageRequestCheckinRegis] = useState("")
    const [errorDateRujukanBalik, setErrorDateRujukanBalik] = React.useState(false)
    const [textErrorDateRujukanBalik, setTextErrorDateRujukanBalik] = React.useState("")
    const [dateRujukanBalik, setDateRujukanBalik] = React.useState(null)
    const [errorDateRujukan, setErrorDateRujukan] = React.useState(false)
    const [textErrorDateRujukan, setTextErrorDateRujukan] = React.useState("")
    const [displayNoAntrian, setDisplayNoAntrian] = useState(null)
    const [visibleFifoCheckin, setVisibleFifoCheckin] = useState(false)
    const [locationRegis, setLocationRegis] = useState(null)
    const [generalConsent, setGeneralConsent] = useState(null)

    const [visibleUpload, setVisibleUpload] = useState(false)
    const [percentage, setpercentage] = useState('0')
    const [uploadstatus, setuploadstatus] = useState("")
    const [result, setresult] = useState("")
    const [file, setFile] = useState(null)
    const [nameFile, setNameFile] = useState(null)
    const [sizeFile, setSizeFile] = useState("")
    const [sizeUpload, setSizeUpload] = useState(null)
    const [isReschedule, setIsReschedule] = useState(false)
    const [newDocter, setnewDocter] = React.useState({
        kodeDokter: "",
        spesialisDokter: "",
        alamat: "",
        durasiperiksa: "",
        namaDokter: "",
        poliklinik: "",
        pengalamanDokter: ""
    })
    const handleOnChange = (e) => {
        const { name, value } = e.target
        setnewDocter({
            ...newDocter,
            [name]: value
        })
    }

    const [kunjungan, setKunjungan] = React.useState(null)
    const listKunjungan = [
        { id: 1, name: "Rujukan FKTP" },
        { id: 2, name: "Rujukan Internal" },
        { id: 3, name: "Kontrol" },
        { id: 4, name: "Rujukan Antar RS" },
    ]

    const dummyList = [
        { name: 'tes' },
        { name: 'tes' },
        { name: 'tes' },
    ]

    React.useEffect(() => {
        console.log(paymentMethod, props);
        setPasienSchedule(data.patient_schedule)
        setNoKartuAsuransi(data.patient.insurance_no === null ? '' : data.patient.insurance_no)
        setNamaPasienAsuransi(data.patient.card_name === null ? '' : data.patient.card_name)
        setNamaPasienBPJS(data.patient.bpjs_name)
        setNoKartuBPJS(data.patient.bpjs_no === "null" ? "" : data.patient.bpjs_no)
        setNoSEP(data.sep_no != null ? data.sep_no !== "undefined" ? data.sep_no : '-':'-')
        setNoRujukan(data.reference_no)
        setDateRujukan(data.reference_date)
        setDateRujukanBalik(data.return_reference_date)
        getCategoryByProvider(data.patient.provider_code)
        let indexKunjungan = listKunjungan.findIndex((val) => val.name === data.bpjs_type_of_visit_id)
        setKunjungan(listKunjungan[indexKunjungan])
        getCategoryProvider()
        getData(id)
        getParamUpload()
    }, [])

    const getParamUpload = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "MAX_FILE_SIZE_APPOINTMENT") {
                            setSizeUpload(Number(item.param_value))
                        }
                    })
                }
            }
        })
    }

    React.useEffect(() => {
        getTimeSlot(paymentMethod && paymentMethod.id, format(new Date(tanggal), 'yyyy-MM-dd'))
        forceUpdate()
    }, [tanggal, paymentMethod])

    const getProviderByCategory = (type, code) => {
        api.create().getProviderByCategory(type).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListProvider(response.data.data)
                    let idProv = response.data.data.findIndex((val) => val.code === code)
                    if (idProv > -1) {
                        setProvider(response.data.data[idProv])
                        forceUpdate()
                    }
                    forceUpdate()
                }
            }
            setLoading(false)
        })
    }

    const getCategoryProvider = () => {
        api.create().getCategoryProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCategoryProvider(response.data.data)
                    forceUpdate()
                }
            }
        })
    }

    const getProviderByCode = (code) => {
        let payload = {
            "business_partner_code": code ? code : data.patient.provider_code,
        }
        console.log(payload);
        api.create().getProviderByCode(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.message === "Data not found!") {
                        setPickCategory(null)
                        setProvider(null)
                        forceUpdate()
                    } else {
                        let idCat = categoryProvider.findIndex((val) => val.type === response.data.data.type)
                        console.log(idCat);
                        if (idCat > -1) {
                            setPickCategory(categoryProvider[idCat])
                            getProviderByCategory(response.data.data.type, response.data.data.code)
                            forceUpdate()
                        }
                    }
                }
            }
        })
    }

    const getListAsuransi = (rm, without) => {
        api.create().getListAsuransi(rm, without).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let array = []
                    if (data.patient_insurances.length > 0) {
                        data.patient_insurances.map((item, index) => {
                            array.push(item)
                        })
                        setArrayAsuransi(array)
                        setVisibleOpenPendukung(true)
                        console.log(array);
                        forceUpdate()
                    } else {
                        setArrayAsuransi([])
                        setOpenAlert(true)
                        setMessageAlert("Anda tidak mempunyai data asuransi")
                        setStatusAlert("warning")
                    }
                } else {
                    setOpenAlert(true)
                    setMessageAlert("Anda tidak mempunyai data asuransi")
                    setStatusAlert("warning")
                }
            }
        })
    }

    const sendWA = () => {
        console.log(data);

        api.create().getLocationRegis(data.appointment_id).then(response => {
            setLocationRegis(response.data.data.location === null ? "-" : response.data.data.location)

            let jam = String(data.doctor_schedule).substring(13)
            // let text2 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa\n\npasien atas nama *${data.patient.name}*\nmemiliki perjanjian terjadwal pada tgl *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\ndengan *${data.doctor.name}*\nNo.Antrian *${data.queue_number === null ? "-" : data.queue_number}*\n(Penjelasan: 2 huruf pertama adalah nama dokter, angka di belakang huruf merupakan nomor sesi praktik dokter, angka di belakang strip adalah nomor antrian Anda pada sesi tersebut).\n\nNo.Kode Booking	: ${data.booking_id}\nMulai pada jam	:${jam}\nPembayaran		: ${data.payment_option_name}\nRegistrasi di		: ${locationRegis === null ? "-" : locationRegis} \n\nCATATAN\n1.Mohon untuk melakukan check-in di ${locationRegis === null ? "-" : locationRegis} menggunakan Id Reservasi yang telah di berikan. Jika menemukan kendala dalam melakukan check-in, silahkan bertanya kepada petugas ditempat.\n2.Check-in dapat dilakukan secara mandiri via mobile apps bagi yang melakukan reservasi dengan apps. Check-in dapat mulai dilakukan sejak 1 jam sebelum jam praktik dimulai dan dilakukan di area ${localStorage.getItem(Constant.NAMA_RS)} (fitur deteksi tempat)\n3.Wajib menggunakan masker dan scan barcode PeduliLindungi dipintu masuk Lobby\n4.Dengan perkiraan pelayanan per pasien memakan waktu 10 menit, Anda dapat membuat perkiraan waktu untuk kedatangan di ${localStorage.getItem(Constant.NAMA_RS)} berdasarkan nomor antrian Anda. Adapun perkiraan tersebut dapat bervariasi, bergantung pada tingkat kesulitan penyakit pasien lain, pergeseran waktu kedatangan dokter, dan adanya kemungkinan didahulukannya pasien emergensi/ gawat darurat yang memerlukan penanganan lebih awal. Mohon dimaklumi kemungkinan perbedaan waktu estimasi kedatangan Anda dengan waktu pelayanan yang sebenarnya.\n\nTerimakasih dan salam sehat`
            // console.log(jam);
            let text1 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: B1, B2 , Lobby GMCB dan Petugas Receptionist\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Gedung GMCB B1, B2 dan Lobby GMCB menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            let text2 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: Loket Jaminan Lt.1 GMCB\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Gedung GMCB B1, B2 dan Lobby GMCB menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            let text3 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: Loket BPJS Center\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Loket BPJS Center menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            // console.log(text1);

            let chat = data.payment_option_id == 1 ? encodeURI(text1) : data.payment_option_id == 2 ? encodeURI(text2) : encodeURI(text3)
            if (data.patient.mobile_phone) {
                window.open(`https://wa.me/62${data.patient.mobile_phone}?text=${chat}`, '_blank');
            } else {
                setMessageAlert("Nomor HP Pasien Tidak Ditemukan")
                setStatusAlert('warning')
                setOpenAlert(true)
            }
        })
    }

    const getData = (id) => {
        api.create().getDetailReservasiDokter(id).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setData(response.data.data)
                    setAlasanBatal(response.data.data.reasons)
                    let fileUpload = []
                    if (response.data.data.patient.media.length > 0) {
                        response.data.data.patient.media.map((item) => {
                            fileUpload.push(item.file_name)
                        })
                    }
                    setFileUpload(fileUpload)
                    forceUpdate()
                }
            }
        })
    }

    const getTimeSlot = (payment, date) => {
        // console.log(payment, date, '----------------');
        let params = `polyclinic_id=${data.polyclinic.id}&date=${format(new Date(tanggal), 'yyyy-MM-dd')}&id=${data.doctor.id}&payment_type=${paymentMethod ? paymentMethod.id : data.payment_option_id}`
        api.create().getTimeSlot(params).then(response => {
            // console.log(response);
            // console.log(data);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        setTimeslot(response.data.data[0].schedule)
                        let idxSchedule = response.data.data[0].schedule.findIndex((val) => val.id === data.doctor_schedule_id)
                        if (idxSchedule > -1) {
                            setTimeValue(idxSchedule)
                            getDetailTimeSlot(response.data.data[0].schedule[idxSchedule], idxSchedule)
                            setVisibleJadwal(true)
                        }
                        setDisableButton(false)
                    } else {
                        setVisibleJadwal(false)
                        setTimeslot([])
                        setPasienSchedule(null)
                    }
                }
            }
        })
        forceUpdate()
    }
    React.useEffect(() => {
        getDataPoli()
        getJadwalPeriksa()
        let indexPayment = listPaymentOption.findIndex((val) => val.name === data.payment_option_id)
        if (slotWaktu != false) {
            let indexSlotWaktu = slotWaktu.findIndex((val) => val.time === pasienSchedule)
            setPasienSchedule(slotWaktu[indexSlotWaktu])
            setTimeId(slotWaktu[indexSlotWaktu])
        }
        setPaymentMethod(listPaymentOption[indexPayment])
    }, [])

    const getCategoryByProvider = (code) => {
        let payload = {
            "business_partner_code": code,
        }
        api.create().getProviderByCode(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.message !== "Data not found!") {
                        let type = String(response.data.data.type).toUpperCase()
                        setCategoryDetail(type)
                        forceUpdate()
                    }
                }
            }
        })
    }

    const handlePaymentOption = () => {
        let indexPayment = listPaymentOption.findIndex((val) => val.id === data.payment_option_id)
        // console.log(indexPayment);
        setPaymentMethod(listPaymentOption[indexPayment])
        forceUpdate()
    }

    const handleKunjungan = () => {
        let index = listKunjungan.findIndex((val) => val.id === data.bpjs_type_of_visit_id)
        // console.log(index);
        setKunjungan(listKunjungan[index])
        forceUpdate()
    }

    const getDetailTimeSlot = (elemen, index) => {
        setDetailDokter(elemen)
        // console.log(elemen, index);
        let temp = []
        elemen.detail_schedule.map((el, idx) => {
            if (el.is_available === 1) {
                temp.push({
                    time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tersedia)`,
                    id: el.id,
                    is_available: "Tersedia",
                    index: idx
                })
            } else {
                temp.push({
                    time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tidak Tersedia)`,
                    id: el.id,
                    is_available: "Tidak Tersedia",
                    index: idx
                })
            }
        })
        if (elemen.time_type === "FIFO") {
            setPasienSchedule(temp[0])
            setTimeId(temp[0].id)
            forceUpdate()
        } else {
            let idxDetail = temp.findIndex((val) => val.id === data.doctor_schedule_detail_id)
            if (idxDetail > -1) {
                // console.log(temp[idxDetail]);
                setPasienSchedule(temp[idxDetail])
                setTimeId(temp[idxDetail].id)
                forceUpdate()
            }
        }
        setSlotWaktu(temp)
    }

    const getJadwalPeriksa = (date) => {
        let formatPlusWeek = new Date(new Date(tanggal).setDate(new Date(tanggal).getDate() + 7))
        const id = data.doctor.id
        let params = `date_filter={"schedule_date": {"start":${date}-${new Date(tanggal).getDate()},"end":${new Date(formatPlusWeek).getFullYear()}-${new Date(formatPlusWeek).getMonth() + 1}-${new Date(formatPlusWeek).getDate()}}}&filter={"doctor_id":[${id}]}`
        // console.log(params);
        // // try {
        let tempId;
        let selectedDate = data.doctor_schedule
        // console.log(typeof selectedDate);
        // let scheduleTime = `${new Date(selectedDate).getFullYear()}`
        // selectedDate = `${new Date(selectedDate).getFullYear()}-${new Date(selectedDate).getMonth() + 1}-${new Date(selectedDate).getDate()}`
        // selectedDate = `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`
        if (date !== undefined) {
            selectedDate = format(new Date(date), 'yyyy-MM-dd')
        }

        api.create().filterDokter(params).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    // console.log(response.data.data[0].polyclinic[0].schedule);
                    let schedule = response.data.data[0].polyclinic[0].schedule
                    let idx = schedule.findIndex((val) => val.date === tanggal)
                    // console.log(idx);
                    if (idx !== -1) {
                        getTimeSchedule(schedule[idx].id)
                        setRoom(schedule[idx].room)
                    }
                }
            }

        })
    }

    const getTimeSchedule = (idDokter) => {
        api.create().getTimeslotDokter(idDokter).then(response => {
            // console.log(response, '----------------');
            if (response.data.data) {
                let temp = []
                response.data.data[0].detail.map((el, idx) => {
                    if (el.is_available === 1) {
                        temp.push({
                            time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tersedia)`,
                            id: el.id,
                            is_available: el.is_available === 0 ? `Tidak Tersedia` : "Tersedia",
                            index: idx
                        })
                    } else {
                        temp.push({
                            time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tidak Tersedia)`,
                            id: el.id,
                            is_available: el.is_available === 0 ? `Tidak Tersedia` : "Tersedia",
                            index: idx
                        })
                    }
                })
                setSlotWaktu(temp)
            }
        })
    }

    const getDataPoli = () => {
        api.create().getListMasterPoli().then(response => {
            // console.log(response);
            if (response.data) {
                setDataPoli(response.data.data)
            }
            setLoading(false)
        })
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
    }

    const uploadFoto = () => {
        setUploadVisible(false)
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleDaftar = () => {
        setStatus(true)
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleCheked = (index) => {
        // console.log(index);
        let a = dataPoli[index].checked = !dataPoli[index].checked
        console.log(dataPoli[index]);
        forceUpdate()
    }

    const handleEmergency = () => {
        setVisibleEmergency(true)
    }

    const handleBatal = () => {
        setVisibleBatal(true)
    }

    const onClose = () => {
        setVisibleEmergency(false)
        setVisibleBatal(false)
        setVisibleCheckIn(false)
        setIsReschedule(false)
        setVisibleCheckInReservation(false)
        setDisableCheckin(false)
    }

    const changeStatus = () => {
        setLoading(true)
        let payload = {
            "appointment_id": data.appointment_id,
            "reasons": alasanBatal,
            "is_admin": true
        }
        api.create().cancelReservation(payload).then(response => {
            // console.log(response);
            if (response.data.message === "Success canceled appointment!") {
                setLoading(false)
                setVisibleBatal(false)
                setIsReschedule(false)
                setOpenAlert(true)
                setMessageAlert(response.data.message)
                setStatusAlert("Success")
                setTimeout(() => {
                    history.goBack()
                }, 1000)
            }
        })
    }

    const handleAddNotes = () => {
        // console.log(catatanPetugas);
        let payload = {
            "appointment_id": data.appointment_id,
            "note": catatanPetugas
        }
        api.create().addNotes(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCatatanPetugas("")
                    getData(id)
                    setVisibleCatatanPetugas(false)
                    setOpenAlertStatus(true)
                    setMessageAlertStatus(String(response.data.message))
                    setStatusAlertStatus("Success")
                    forceUpdate()
                }
            }
        })
    }

    const submitEmergency = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": doctor_schedule_detail_id, // kebalik
            "doctor_schedule_detail_id": doctor_schedule_id,
        }
        // console.log(payload);
        api.create().emergencyReservation(payload).then(response => {
            // console.log(response);
            if (response.data.message === "Doctor queue successfully updated to emergency status!") {
                setLoading(false)
                setVisibleEmergency(false)
                setOpenAlert(true)
                setMessageAlert("Antrian dokter berhasil di perbarui")
                setStatusAlert("Success")
                setTimeout(() => {
                    history.replace({
                        pathname: '/dokter/reservasi-dokter',
                        name: 'Reservasi',
                    })
                }, 1500)
            }
        })
    }

    const handleBack = () => {
        if (location.state.intent === "daftar") {
            history.replace({
                pathname: '/dokter/reservasi-dokter',
                name: 'Reservasi',
            })
        } else {
            setTimeout(() => {
                history.goBack()
            }, 100)
        }
    }

    const submitCheckIn = (e) => {
        setLoading(true)
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1
        }
        // console.log(payload)
        api.create().checkIn(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        setDisplayNoAntrian(response.data.data.queue_number)
                        if (response.data.data.queue_number !== null && response.data.data.time_type === 4) {
                            setVisibleNomorAntrian(true)
                        } else {
                            handleBack()
                        }
                    }
                } else if (response.data.data) {
                    if (String(response.data.data).includes("Apakah anda yakin")) {
                        setVisibleCheckIn(false)
                        setVisibleForceCheckin(true)
                        setErrorMessageRequestCheckin(response.data.data)
                    } else {
                        // console.log('---------------2');
                        setVisibleCheckIn(false)
                        setDisableCheckin(false)
                        setErrorRequest(true)
                        setErrorMessageRequest(response.data.data)
                    }
                }
                setLoading(false)
            }
        })
    }

    const submitCheckInDanRegis = () => {
        setLoading(true)
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1,
            'with_registration': 1,
        }
        api.create().checkIn(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        setDisplayNoAntrian(response.data.data.queue_number)
                        if (response.data.data.queue_number !== null && response.data.data.time_type === 4) {
                            setVisibleNomorAntrian(true)
                        } else {
                            handleBack()
                        }
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Succes")
                    }
                } else if (response.data.data) {
                    if (String(response.data.data).includes("Apakah anda yakin")) {
                        setVisibleCheckIn(false)
                        setVisibleForceCheckinRegis(true)
                        setErrorMessageRequestCheckinRegis(response.data.data)
                    } else {
                        // console.log('---------------2');
                        setVisibleCheckIn(false)
                        setDisableCheckin(false)
                        setErrorRequest(true)
                        setErrorMessageRequest(response.data.data)
                    }
                }
                setLoading(false)
            }
        })
    }

    const handleForceCheckin = () => {
        setLoading(true)
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1,
            'force_checkin': 1
        }
        // console.log(payload)
        api.create().checkIn(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        if (location.state.intent === "daftar") {
                            history.replace({
                                pathname: '/dokter/reservasi-dokter',
                                name: 'Reservasi',
                            })
                        } else {
                            setTimeout(() => {
                                history.goBack()
                            }, 100)
                        }
                    }
                } else if (response.data.data) {
                    setVisibleCheckIn(false)
                    setDisableCheckin(false)
                    setErrorRequest(true)
                    setErrorMessageRequest(response.data.data)
                }
                setLoading(false)
            }
        })
    }

    const handleForceCheckinRegis = () => {
        setLoading(true)
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1,
            'with_registration': 1,
            'force_checkin': 1
        }
        // console.log(payload)
        api.create().checkIn(payload).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        if (location.state.intent === "daftar") {
                            history.replace({
                                pathname: '/dokter/reservasi-dokter',
                                name: 'Reservasi',
                            })
                        } else {
                            setTimeout(() => {
                                history.goBack()
                            }, 100)
                        }
                    }
                } else if (response.data.data) {
                    setVisibleCheckIn(false)
                    setDisableCheckin(false)
                    setErrorRequest(true)
                    setErrorMessageRequest(response.data.data)
                }
                setLoading(false)
            }
        })
    }

    const listPaymentOption = [
        {
            id: 1,
            name: "UMUM"
        },
        {
            id: 2,
            name: "Jaminan Non-BPJS Kesehatan"
        },
        {
            id: 3,
            name: "BPJS"
        },
    ]

    const doEdit = () => {
        if (paymentMethod) {
            if (paymentMethod.id === 3) {
                if (!isReschedule && noRujukan !== "" && dateRujukan === null) {
                    setErrorDateRujukan(true)
                    setTextErrorDateRujukan("Tanggal Rujukan wajib diisi")
                    setLoading(false)
                } else {
                    let payload = {
                        "appointment_id": data.appointment_id,
                        "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                        "is_admin": true,
                        "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                        "bpjs_type_of_visit": kunjungan !== undefined ? kunjungan.id : data.bpjs_type_of_visit_id,
                        "reference_no": noRujukan,
                        "patient_bpjs_no": noKartuBPJS,
                        "patient_bpjs_name": namaPasienBPJS,
                        "reference_date": dateRujukan && format(new Date(dateRujukan), 'yyyy-MM-dd'),
                        "return_reference_date": dateRujukanBalik && format(new Date(dateRujukanBalik), 'yyyy-MM-dd'),
                        "sep_no": noSEP
                    }
                    if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                        payload = {
                            ...payload,
                            "edit_before_checkin": 1
                        }
                    }
                    // console.log(payload);
                    api.create().reschedule(payload).then(response => {
                        // console.log(response);
                        if (response.data) {
                            if (response.data.status === true) {
                                if (response.data.data.queue_number === null) {
                                    setVisibleFifoCheckin(true)
                                } else {
                                    setVisibleEdit(false)
                                    setIsReschedule(false)
                                }
                                setMessageAlert(response.data.message)
                                setStatusAlert("success")
                                setOpenAlert(true)
                                // setVisibleEdit(false)
                                // setIsReschedule(false)
                                getData(id)
                                forceUpdate()
                            } else {
                                if (response.data.data) {
                                    if (response.data.data.includes("Apakah anda yakin")) {
                                        setErrorForce(true)
                                        setErrorMessage(response.data.data)
                                    } else {
                                        setError(true)
                                        setErrorMessage(response.data.data)
                                    }
                                }
                            }
                        }
                    })
                }
            } else if (paymentMethod.id === 2) {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "patient_insurance_no": noKartuAsuransi,
                    "patient_insurance_card_name": namaPasienAsuransi,
                    "patient_provider_code": provider ? provider.code : null,
                    "patient_insurance_name": provider ? provider.name : null,
                    "patient_provider_category": pickCategory ? pickCategory.type : null,
                    "patient_insurance_id": pickAsuransi === null ? data.patient.insurance_id : pickAsuransi.insurance_no,
                    "sep_no": noSEP
                }
                if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                    payload = {
                        ...payload,
                        "edit_before_checkin": 1
                    }
                }
                // console.log(payload);
                api.create().reschedule(payload).then(response => {
                    // console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            if (response.data.data.queue_number === null) {
                                setVisibleFifoCheckin(true)
                            } else {
                                setVisibleEdit(false)
                                setIsReschedule(false)
                            }
                            setMessageAlert(response.data.message)
                            setStatusAlert("success")
                            setOpenAlert(true)
                            // setVisibleEdit(false)
                            // setIsReschedule(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.includes("Apakah anda yakin")) {
                                    setErrorForce(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setError(true)
                                    setErrorMessage(response.data.data)
                                }
                            }
                        }
                    }
                })
            } else {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "sep_no": noSEP
                }
                if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                    payload = {
                        ...payload,
                        "edit_before_checkin": 1
                    }
                }
                // console.log(payload);
                api.create().reschedule(payload).then(response => {
                    // console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            if (response.data.data.queue_number === null) {
                                setVisibleFifoCheckin(true)
                            } else {
                                setVisibleEdit(false)
                                setIsReschedule(false)
                            }
                            setMessageAlert(response.data.message)
                            setOpenAlert(true)
                            setStatusAlert("success")
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.includes("Apakah anda yakin")) {
                                    setErrorForce(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setError(true)
                                    setErrorMessage(response.data.data)
                                }
                            }
                        }
                    }
                })
            }
        }
    }

    const handleForceReschedule = () => {
        if (paymentMethod) {
            if (paymentMethod.id === 3) {
                if (!isReschedule && noRujukan !== "" && dateRujukan === null) {
                    setErrorDateRujukan(true)
                    setTextErrorDateRujukan("Tanggal Rujukan wajib diisi")
                    setLoading(false)
                } else {
                    let payload = {
                        "appointment_id": data.appointment_id,
                        "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                        "is_admin": true,
                        "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                        "bpjs_type_of_visit": kunjungan !== undefined ? kunjungan.id : data.bpjs_type_of_visit_id,
                        "reference_no": noRujukan,
                        "patient_bpjs_no": noKartuBPJS,
                        "patient_bpjs_name": namaPasienBPJS,
                        "force_reschedule": 1,
                        "reference_date": dateRujukan && format(new Date(dateRujukan), 'yyyy-MM-dd'),
                        "return_reference_date": dateRujukanBalik && format(new Date(dateRujukanBalik), 'yyyy-MM-dd'),
                    }
                    if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                        payload = {
                            ...payload,
                            "edit_before_checkin": 1
                        }
                    }
                    // console.log(payload);
                    api.create().reschedule(payload).then(response => {
                        // console.log(response);
                        if (response.data) {
                            if (response.data.status === true) {
                                setMessageAlert(response.data.message)
                                setOpenAlert(true)
                                setStatusAlert("success")
                                setVisibleEdit(false)
                                setIsReschedule(false)
                                setErrorForce(false)
                                getData(id)
                                forceUpdate()
                            } else {
                                if (response.data.data) {
                                    if (response.data.data.includes("Apakah anda yakin")) {
                                        setErrorForce(true)
                                        setErrorMessage(response.data.data)
                                    } else {
                                        setError(true)
                                        setErrorMessage(response.data.data)
                                    }
                                }
                            }
                        }
                    })
                }
            } else if (paymentMethod.id === 2) {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "patient_insurance_no": noKartuAsuransi,
                    "patient_insurance_card_name": namaPasienAsuransi,
                    "patient_provider_code": provider ? provider.code : null,
                    "patient_insurance_name": provider ? provider.name : null,
                    "patient_provider_category": pickCategory ? pickCategory.type : null,
                    "patient_insurance_id": pickAsuransi === null ? data.patient.insurance_id : pickAsuransi.insurance_no,
                    "force_reschedule": 1
                }
                if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                    payload = {
                        ...payload,
                        "edit_before_checkin": 1
                    }
                }
                // console.log(payload);
                api.create().reschedule(payload).then(response => {
                    // console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setOpenAlert(true)
                            setStatusAlert("success")
                            setVisibleEdit(false)
                            setIsReschedule(false)
                            setErrorForce(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.includes("Apakah anda yakin")) {
                                    setErrorForce(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setError(true)
                                    setErrorMessage(response.data.data)
                                }
                            }
                        }
                    }
                })
            } else {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": isReschedule ? pasienSchedule && pasienSchedule.id : data.doctor_schedule_detail_id,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "force_reschedule": 1
                }
                if ((isReschedule === false && data.appointment_status_id === 1) || (isReschedule === false && data.appointment_status_id === 2)) {
                    payload = {
                        ...payload,
                        "edit_before_checkin": 1
                    }
                }
                // console.log(payload);
                api.create().reschedule(payload).then(response => {
                    // console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setOpenAlert(true)
                            setStatusAlert("success")
                            setVisibleEdit(false)
                            setIsReschedule(false)
                            setErrorForce(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.includes("Apakah anda yakin")) {
                                    setErrorForce(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setError(true)
                                    setErrorMessage(response.data.data)
                                }
                            }
                        }
                    }
                })
            }
        }
    }

    const handleButton = (item) => {
        if (item.is_holiday === 1) {
            setDisableButton(true)
        } else {
            setDisableButton(false)
        }
    }

    const fileHandler = (event) => {
        // console.log(event)
        setNameFile(event.name)
        setSizeFile((event.size / 1000).toFixed(0))
        setFile(event)
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 2000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>

            <Snackbar open={openAlertStatus} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlertStatus}>
                    {messageAlertStatus}
                </Alert>
            </Snackbar>
            {
                loading && (loadingComponent)
            }
            {
                !visibleEdit ?
                    <div style={{ height: '89vh', overflow: 'auto', fontFamily: 'Poppins', padding: 20, marginBottom: 20 }}>
                        <div style={{ marginTop: 20, marginLeft: 33 }}>
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 15 }}>
                                    {/* <ReactToPrint
                                        pageStyle={pageStyle}
                                        trigger={() => {
                                            return (
                                                <div
                                                    style={{ height: 34, backgroundColor: '#65ae92', borderRadius: 20, cursor: 'pointer', marginTop: 0, padding: '0 10px' }}
                                                // style={{ cursor: 'pointer', height: '4vh', width: '25vh', backgroundColor: '#34b68b', borderRadius: '10vh', borderColor: '#34b68b', borderWidth: '.4vh', borderStyle: 'solid', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                                >
                                                    <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 7, cursor: 'pointer' }}>
                                                        <img src={print} style={{ width: 18, height: 18, marginRight: 10 }} />
                                                        <Typography style={{ color: '#ffffff', textAlign: 'center', fontSize: 16, marginTop: -2, marginRight: 4 }}>Print SEP</Typography>
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        content={() => componentToPrint.current}
                                    >
                                    </ReactToPrint> */}
                                    <ReactToPrint
                                        pageStyle={pageStyle}
                                        trigger={() => {
                                            return (
                                                <div
                                                    style={{ height: 34, backgroundColor: '#65ae92', borderRadius: 20, cursor: 'pointer', marginTop: 0, padding: '0 10px' }}
                                                // style={{ cursor: 'pointer', height: '4vh', width: '25vh', backgroundColor: '#34b68b', borderRadius: '10vh', borderColor: '#34b68b', borderWidth: '.4vh', borderStyle: 'solid', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                                >
                                                    <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 7, cursor: 'pointer' }}>
                                                        <img src={print} style={{ width: 18, height: 18, marginRight: 10 }} />
                                                        <Typography style={{ color: '#ffffff', textAlign: 'center', fontSize: 16, marginTop: -2, marginRight: 4 }}>Print</Typography>
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        content={() => componentToPrint.current}
                                    >
                                    </ReactToPrint>
                                    <div style={{ display: 'none' }}>
                                        <ComponentToPrint
                                            namaDokter={data.doctor.name}
                                            desc={data.doctor.speciality}
                                            namaPoli={data.polyclinic.name}
                                            noRekam={data.patient.medical_record_no}
                                            namaPasien={data.patient.name}
                                            dateTime={displayDate}
                                            pembayaran={data.payment_option_name}
                                            dokterRoom={data.location}
                                            noAntrian={data.queue_number}
                                            qrCodeURL={data.booking_id}
                                            bookingID={data.booking_id}
                                            gender={data.patient.gender}
                                            sep_no={data.sep_no}
                                            noRegistrasi={data.registration_no_client}
                                            ref={componentToPrint}
                                        />
                                    </div>
                                    <div style={{ backgroundColor: '#65ae92', color: 'white', height: 34, borderRadius: 30, marginLeft: 10, padding: '0 10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2, cursor: 'pointer' }}
                                            onClick={() => {
                                                setVisibleEdit(true)
                                                getProviderByCode()
                                                handlePaymentOption()
                                                handleKunjungan()
                                            }}
                                        >
                                            <img src={ic_edit} style={{ width: 30, height: 32 }} />
                                            <Typography style={{ textAlign: 'center', fontSize: 16, marginTop: 3, marginRight: 5 }}>Edit</Typography>
                                        </div>
                                    </div>
                                    {generalConsent ?
                                        <ReactToPrint
                                            pageStyle={pageStyle}
                                            trigger={() => {
                                                return (
                                                    <div
                                                        style={{ marginLeft: 10, height: 34, backgroundColor: '#65ae92', borderRadius: 20, cursor: 'pointer', marginTop: 0, padding: '0 10px' }}
                                                    // style={{ cursor: 'pointer', height: '4vh', width: '25vh', backgroundColor: '#34b68b', borderRadius: '10vh', borderColor: '#34b68b', borderWidth: '.4vh', borderStyle: 'solid', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                                    >
                                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2, cursor: 'pointer' }}>
                                                            <img src={print} style={{ width: 18, height: 18, margin: '6px 8px' }} />
                                                            <Typography style={{ textAlign: 'center', fontSize: 16, marginTop: 3, marginRight: 5, color: '#fff' }}>Cetak GC</Typography>
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            content={() => componentGC.current}
                                        >
                                        </ReactToPrint>
                                        :
                                        null
                                    }
                                    <div style={{ display: 'none' }}>
                                        <ComponentGC
                                            dataContent={generalConsent}
                                            ref={componentGC}
                                        />
                                    </div>
                                    <div style={{ backgroundColor: '#65ae92', color: 'white', height: 34, borderRadius: 30, marginLeft: 10, padding: '0 10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2, cursor: 'pointer' }}
                                            onClick={() => {
                                                sendWA()
                                            }}
                                        >
                                            <NotificationsNoneOutlinedIcon style={{ paddingTop: 5 }} />
                                            <Typography style={{ textAlign: 'center', fontSize: 16, marginTop: 3, marginRight: 5 }}>Reminder</Typography>
                                        </div>
                                    </div>
                                    <div style={{ backgroundColor: '#65ae92', color: 'white', height: 34, borderRadius: 30, marginLeft: 10, padding: '0 10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2, cursor: 'pointer' }}
                                            onClick={() => {
                                                setVisibleEdit(true)
                                                setIsReschedule(true)
                                                getProviderByCode()
                                                handlePaymentOption()
                                                handleKunjungan()
                                            }}
                                        >
                                            <img src={ic_edit} style={{ width: 30, height: 32 }} />
                                            <Typography style={{ textAlign: 'center', fontSize: 16, marginTop: 3, marginRight: 5 }}>Reschedule</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                                <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550 }}>Data Reservasi</Typography>
                            </div>
                            <div className="grid grid-2x grid-mobile-none " style={{ padding: '0px 20px 20px 20px', }}>
                                <div className="column-1">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', borderBottom: 'none !important' }}
                                            id="opsiPembayaran"
                                            name="opsiPembayaran"
                                            label="Opsi Pembayaran"
                                            value={data.payment_option_name}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                            <DatePicker
                                                margin="normal"
                                                id="validFrom"
                                                label="Tanggal"
                                                format="dd MMM yyyy"
                                                defaultValue="Pilih tanggal dan waktu"
                                                value={data.appointment_date}
                                                // onChange={(date) => {
                                                //     pertanyaanLength.tanggalBerlaku = new Date(date).toLocaleDateString()
                                                // }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: '85%', margin: '10px 0px 0px' }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: 'black'
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="jadwalPeriksa"
                                            name="jadwalPeriksa"
                                            label="Jadwal Periksa"
                                            value={data.patient_schedule}
                                            onChange={(e) => {
                                                alert('a')
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="reservasi"
                                            name="reservasi"
                                            label="Reservasi Via"
                                            value={data.reservation_from || "-"}
                                            onChange={(e) => {
                                                // setTextAlamat("")
                                                // setErrorAlamat(true)
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="column-2">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', cursor: 'default' }}
                                            // onClick={() => setVisibleSetListPoli(true)}
                                            name='Opsi Pembayaran'
                                            id="payment"
                                            label="Klinik"
                                            defaultValue="Pilih Klinik"
                                            value={`Poliklinik ${data.polyclinic.name}`}
                                            // onChange={(event, newInputValue) => {
                                            //     // setPoliklinik(newInputValue)
                                            // }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="namaDokter"
                                            name="namaDokter"
                                            label="Nama Dokter"
                                            value={data.doctor.name}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="namaDokter"
                                            name="namaDokter"
                                            label="Lokasi Praktek Dokter"
                                            defaultValue=" "
                                            value={data.location}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginLeft: 33 }}>
                            <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550 }}>Kelengakapan Data Pasien</Typography>
                            <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                <div className="column-1">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%' }}
                                            id="idReservasi"
                                            name="idReservasi"
                                            label="ID Reservasi"
                                            value={data.booking_id}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 18 }}
                                            id="queue"
                                            name="queue"
                                            label="No Antrian"
                                            value={data.queue_number ? data.queue_number : '-'}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="noRekam"
                                            name="noRekam"
                                            label="No Rekam Medis"
                                            value={data.patient.medical_record_no || "-"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(false)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="jenisKelamin"
                                            name="jenisKelamin"
                                            label="Jenis Kelamin"
                                            value={data.patient.gender === 'L' ? "Laki-Laki" : "Perempuan"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(false)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="noHp"
                                            name="noHp"
                                            label="No. Telepon"
                                            value={data.patient.phone}
                                            // error={errorNoSTR}
                                            // helperText={textNoSTR}
                                            placeholder={"input No hp pasien"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(false)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 10 }}
                                        id="inputKeluhan"
                                        name="inputKeluhan"
                                        label="Catatan Pasien"
                                        value={data.notes === "" || data.notes === null || data.notes === "null" ? "-" : data.notes}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                                color: 'black'
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: 500
                                            }
                                        }}
                                        disabled={true}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                                <div className="column-2">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%' }}
                                            id="namaPasien"
                                            name="namaPasien"
                                            label="Nama Pasien"
                                            value={data.patient.name}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="noKtp"
                                            name="noKtp"
                                            label="No KTP"
                                            value={data.patient.identity_no || "-"}
                                            onChange={(e) => {
                                                // setErrorNama(false)
                                                // setTextNama("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />

                                        {/* <Autocomplete
                                        style={{width: '85%', marginTop: 20}}
                                        options={dummyList}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='jenisKelamin'
                                        id="jenisKelamin"
                                        defaultValue="pilih jenis kelamin"
                                        onChange={(event, newInputValue) => {
                                            // setPoliklinik(newInputValue)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Jenis Kelamin"
                                            />
                                        }
                                    /> */}
                                    </div>
                                    <div className="">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                            <DatePicker
                                                margin="normal"
                                                id="bod"
                                                label="Tanggal Lahir"
                                                format="dd MMM yyyy"
                                                defaultValue="Pilih tanggal lahir pasien"
                                                value={new Date(data.patient.date_of_birth)}
                                                // onChange={(date) => {
                                                //     pertanyaanLength.tanggalBerlaku = new Date(date).toLocaleDateString()
                                                // }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: 'black'
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                style={{ width: '85%' }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 7 }}
                                            id="alamat"
                                            name="alamat"
                                            label="Alamat"
                                            value={data.patient.address || "-"}
                                            onChange={(e) => {
                                                // setTextAlamat("")
                                                // setErrorAlamat(false)
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            label="No. Handphone"
                                            value={data.patient.mobile_phone}
                                            // error={errorNoSTR}
                                            // helperText={textNoSTR}
                                            placeholder={"input No hp pasien"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(false)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: 'black'
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div style={{ marginLeft: 33 }}>
                            <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550, textAlign: 'left' }}>File Pendukung</Typography>
                            <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px' }}>
                                <div className="column-1">
                                    <div className="">
                                        <Typography style={{ fontSize: 13, color: '#7e8085', fontWeight: 500 }}>Upload File Medical Check Up / LAB</Typography>
                                        {data.patient.media.length > 0 ?
                                            data.patient.media.map((item) => {
                                                return (
                                                    <div
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            window.open(item.file_url, "_blank")
                                                        }}>
                                                        <Typography style={{ fontSize: 14, color: 'black' }}>{item.file_name}</Typography>
                                                    </div>
                                                )
                                            })
                                            :
                                            <Typography style={{ fontSize: 14, color: 'black' }}>-</Typography>
                                        }
                                    </div>
                                    {data.payment_option_id === 3 ?
                                        <div>
                                            <div style={{ textAlign: 'left'}}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Rumah Sakit Eksternal"
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={data.external_hospital_name === null || data.external_hospital_name === "" ? '-' : data.external_hospital_name}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div style={{ textAlign: 'left',  marginTop: 10 }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Jenis Kunjungan"
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={data.bpjs_type_of_visit_name ? data.bpjs_type_of_visit_name : '-'}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Tanggal Rujukan"
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={data.reference_date ? data.reference_date : '-'}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {data.return_reference_date && data.appointment_status_id === 3 && (
                                                <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Jadwal Kontrol"
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        value={data.return_reference_date ? data.return_reference_date : '-'}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Nomor SEP"
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={noSEP}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Nama Pasien BPJS"
                                                    placeholder={"Input Nama Pasien BPJS"}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={data.patient.bpjs_name === null || data.patient.bpjs_name === "" ? '-' : data.patient.bpjs_name}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div> :
                                        data.payment_option_id === 2 ?
                                            <div>
                                                <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Kategori Jaminan"
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                        value={data.patient.provider_category === null ? '-' : data.patient.provider_category}
                                                    />
                                                </div>
                                                <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="No Kartu Peserta Jaminan"
                                                        placeholder={"Input No Kartu Peserta Jaminan"}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                        value={data.patient.insurance_no === null ? '-' : data.patient.insurance_no}
                                                    />
                                                </div>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div className="column-2">
                                    {data.payment_option_id === 3 ?
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                disabled
                                                style={{ width: '85%' }}
                                                label="No Rujukan"
                                                placeholder={"Input No Rujukan"}
                                                value={data.reference_no ? data.reference_no : '-'}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: 'black'
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />

                                            {data.return_reference_date && data.appointment_status_id === 3 && (

                                                <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Jadwal Kontrol"
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        value={data.return_reference_date ? data.return_reference_date : '-'}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                disabled
                                                label="No Kartu"
                                                placeholder={"Input No Kartu BPJS"}
                                                value={!data.patient.bpjs_no ? '-' : data.patient.bpjs_no === 'null' || data.patient.bpjs_no === "" ? '-' : data.patient.bpjs_no}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: 'black'
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />

                                            <TextField
                                                disabled
                                                style={{ width: '85%' }}
                                                label="Jenis Kunjungan"
                                                // placeholder={"Input No Rujukan"}
                                                value={data.bpjs_type_of_visit_name ? data.bpjs_type_of_visit_name : '-'}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: 'black'
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />
                                        </div> :
                                        data.payment_option_id === 2 ?
                                            <div style={{ textAlign: 'left' }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Provider"
                                                    value={data.patient.insurance_name === null || data.patient.insurance_name === "" ? '-' : data.patient.insurance_name}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%', marginTop: 10 }}
                                                    label="Nama Tertera Dikartu Jaminan"
                                                    placeholder={"Input Nama Tertera Dikartu Jaminan"}
                                                    value={data.patient.card_name === null ? "-" : data.patient.card_name}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                        <div style={{ marginLeft: 33 }}>
                            <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550 }}>Status</Typography>
                            <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', }}>
                                <div className="column1">
                                    <div style={{ width: '100%' }}>
                                        <TextField
                                            label="Created Date"
                                            value={
                                                data.appointment_status.book.date_time === null ? "-" : format(new Date(String(data.appointment_status.book.date_time)), 'dd MMM yyyy HH:mm')
                                            }
                                            style={{ width: '100%' }}
                                            disabled={true}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: '500'
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '100%', marginTop: 10 }}
                                            label="Status Emergency/Darurat"
                                            value={data.is_emergency === 1 ? `${data.queue_number}` : "-"}
                                            disabled={true}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: '500'
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        {
                                            data.appointment_status_name === "Cancel" ?
                                                <TextField
                                                    label="Alasan Batal"
                                                    style={{ width: '100%' }}
                                                    value={data.reasons || '-'}
                                                    disabled={true}
                                                    multiline
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: '500'
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                                : null
                                        }
                                    </div>
                                    {data.appointment_status_name !== "Book" && (
                                        <div style={{ marginTop: 10, width: '100%' }}>
                                            <TextField
                                                label="Updated Date"
                                                value={
                                                    data.appointment_status_name === "Done" ? data.appointment_status.done.date_time === null ? "-" : format(new Date(String(data.appointment_status.done.date_time)), 'dd MMM yyyy HH:mm') :
                                                        data.appointment_status_name === "Cancel" ? data.appointment_status.cancel.date_time === null ? "-" : format(new Date(String(data.appointment_status.cancel.date_time)), 'dd MMM yyyy HH:mm') :
                                                            data.appointment_status_name === "Hold" ? data.appointment_status.hold.date_time === null ? "-" : format(new Date(String(data.appointment_status.hold.date_time)), 'dd MMM yyyy HH:mm') :
                                                                data.appointment_status_name === "Check-In" ? data.appointment_status.checkin.date_time === null ? "-" : format(new Date(String(data.appointment_status.checkin.date_time)), 'dd MMM yyyy HH:mm') :
                                                                    data.appointment_status_name === "Reschedule" ? data.appointment_status.reschedule.date_time === null ? "-" : format(new Date(String(data.appointment_status.reschedule.date_time)), 'dd MMM yyyy HH:mm') : "-"

                                                }
                                                style={{ width: 400 }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: '500'
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="column2">
                                    <div style={{ width: '100%' }}>
                                        <TextField
                                            label="Created By"
                                            value={
                                                data.appointment_status.book.user_name == null ? "-" : data.appointment_status.book.user_name
                                            }
                                            style={{ width: 400 }}
                                            disabled={true}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: '500'
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: '100%', marginTop: 10 }}>
                                        <TextField
                                            label="Status Reservasi"
                                            value={data.appointment_status_name}
                                            style={{ width: 400 }}
                                            disabled={true}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: '500'
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    {data.appointment_status_name === "Cancel" && (
                                        <div style={{ width: '100%', marginTop: 10 }}>
                                            <TextField
                                                label=""
                                                value={""}
                                                style={{ width: 400 }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: '500'
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                    {data.appointment_status_name !== "Book" && (
                                        <div style={{ marginTop: 10, width: '100%' }}>
                                            <TextField
                                                label="Updated By"
                                                value={
                                                    data.appointment_status_name === "Done" ? data.appointment_status.done.user_name == null ? "-" : data.appointment_status.done.user_name :
                                                        data.appointment_status_name === "Cancel" ? data.appointment_status.cancel.user_name == null ? "-" : data.appointment_status.cancel.user_name :
                                                            data.appointment_status_name === "Hold" ? data.appointment_status.hold.user_name == null ? "-" : data.appointment_status.hold.user_name :
                                                                data.appointment_status_name === "Check-In" ? data.appointment_status.checkin.user_name == null ? "-" : data.appointment_status.checkin.user_name :
                                                                    data.appointment_status_name === "Reschedule" ? data.appointment_status.reschedule.user_name == null ? "-" : data.appointment_status.reschedule.user_name : "-"
                                                }
                                                style={{ width: 400 }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: '500'
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                        <div style={{ marginLeft: 33 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550 }}>Catatan Follow Up Petugas</Typography>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '28%' }}>
                                    <div style={{ alignSelf: 'center' }}
                                        onClick={() => {
                                            if (expand === false) {
                                                setExpand(true)
                                            } else {
                                                setExpand(false)
                                            }
                                        }}
                                    >
                                    </div>
                                    <div onClick={() => setVisibleCatatanPetugas(true)} title="Tambah Catatan" style={{ cursor: 'pointer', width: 200 }}>
                                        <Typography style={{ color: '#0066ff', textDecoration: 'underline', fontSize: 16, fontWeight: 500, textAlign: 'center' }} >+ Tambah Catatan</Typography>
                                    </div>
                                </div>
                            </div>
                            {
                                data.appointment_notes != false && expand === true ?
                                    data.appointment_notes.map((el, idx) => {
                                        // console.log(el);
                                        let tanggal = new Date(el.created_at).getDate() < 10 ? `0${new Date(el.created_at).getDate()}` : new Date(el.created_at).getDate()
                                        let bulan = new Date(el.created_at).getMonth()
                                        let tahun = new Date(el.created_at).getFullYear()
                                        let jam = new Date(el.created_at).getHours() < 10 ? `0${new Date(el.created_at).getHours()}` : new Date(el.created_at).getHours()
                                        let menit = new Date(el.created_at).getMinutes() < 10 ? `0${new Date(el.created_at).getMinutes()}` : new Date(el.created_at).getMinutes()
                                        switch (bulan) {
                                            case 0:
                                                bulan = "Jan"
                                                break;
                                            case 1:
                                                bulan = "Fab"
                                                break;
                                            case 2:
                                                bulan = "Mar"
                                                break;
                                            case 3:
                                                bulan = "Apr"
                                                break;
                                            case 4:
                                                bulan = "Mei"
                                                break;
                                            case 5:
                                                bulan = "Jun"
                                                break;
                                            case 6:
                                                bulan = "Jul"
                                                break;
                                            case 7:
                                                bulan = "Agus"
                                                break;
                                            case 8:
                                                bulan = "Sep"
                                                break;
                                            case 9:
                                                bulan = "Oct"
                                                break;
                                            case 10:
                                                bulan = "Nov"
                                                break;
                                            default:
                                                bulan = "Dese"
                                                break;
                                        }
                                        return (
                                            <div>
                                                <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <div className="column1">
                                                        <Typography style={{ color: '#a4a4a4', fontSize: 18, fontWeight: 500 }}>{el.created_by}</Typography>
                                                    </div>
                                                    <div className="column2">
                                                        <Typography style={{ color: '#a4a4a4', fontSize: 13, fontWeight: 400, justifyContent: 'flex-end', display: 'flex' }}>{`${tanggal} ${bulan} ${tahun} ${jam}:${menit}`}</Typography>
                                                    </div>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                                    <Typography style={{ width: '150%', fontSize: 14 }}>{el.notes}</Typography>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                                    <img src={line} style={{ width: '200%' }} />
                                                </div>
                                            </div>
                                        )
                                    })
                                    : data.appointment_notes != false && data.appointment_notes.length >= 0 ?
                                        <div>
                                            <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', display: 'flex', justifyContent: 'space-between', width: '95%' }}>
                                                <div className="column1">
                                                    <Typography style={{ color: '#a4a4a4', fontSize: 18, fontWeight: 500 }}>{data.appointment_notes[0].created_by}</Typography>
                                                </div>
                                                <div className="column2">
                                                    <Typography style={{ color: '#a4a4a4', fontSize: 13, fontWeight: 400, display: 'flex', justifyContent: 'flex-end' }}>
                                                        {
                                                            `${new Date(data.appointment_notes[0].created_at).getDate() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getDate()}` : new Date(data.appointment_notes[0].created_at).getDate()}
                                                ${new Date(data.appointment_notes[0].created_at).getMonth() === 0 ? "Jan" : new Date(data.appointment_notes[0].created_at).getMonth() === 1 ? "Feb" : new Date(data.appointment_notes[0].created_at).getMonth() === 2 ? "Mar" : new Date(data.appointment_notes[0].created_at).getMonth() === 3 ? "Apr" : new Date(data.appointment_notes[0].created_at).getMonth() === 4 ? "Mei" : new Date(data.appointment_notes[0].created_at).getMonth() === 5 ? "Jun" : new Date(data.appointment_notes[0].created_at).getMonth() === 6 ? "Jul" : new Date(data.appointment_notes[0].created_at).getMonth() === 7 ? "Aug" : new Date(data.appointment_notes[0].created_at).getMonth() === 8 ? "Sep" : new Date(data.appointment_notes[0].created_at).getMonth() === 9 ? "Oct" : new Date(data.appointment_notes[0].created_at).getMonth() === 10 ? "Nov" : new Date(data.appointment_notes[0].created_at).getMonth() === 11 ? "Des" : null}
                                                ${new Date(data.appointment_notes[0].created_at).getFullYear()}
                                                ${new Date(data.appointment_notes[0].created_at).getHours() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getHours()}` : new Date(data.appointment_notes[0].created_at).getHours()}:${new Date(data.appointment_notes[0].created_at).getMinutes() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getMinutes()}` : new Date(data.appointment_notes[0].created_at).getMinutes()}
                                                `
                                                        }
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                            </div>
                                            <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                                <Typography style={{ width: '150%', fontSize: 14 }}>{data.appointment_notes[0].notes}</Typography>
                                            </div>
                                            <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', marginTop: -30 }}>
                                                <img src={line} style={{ width: '200%' }} />
                                            </div>
                                        </div>
                                        : null
                            }
                            {
                                data.appointment_notes.length != false && data.appointment_notes.length > 1 && expand === false ?
                                    <Typography onClick={() => setExpand(true)} style={{ cursor: 'pointer', color: '#278863', textAlign: 'center', fontSize: 15, fontWeight: 500 }}>Lihat Semua Catatan</Typography>
                                    : data.appointment_notes.length != false && data.appointment_notes.length > 1 && expand === true ?
                                        <Typography onClick={() => setExpand(false)} style={{ cursor: 'pointer', color: '#278863', textAlign: 'center', fontSize: 15, fontWeight: 500 }}>Lihat Lebih Sedikit</Typography>
                                        : null
                            }
                        </div>
                        <div className="column-2" style={{ display: 'flex', justifyContent: data.appointment_date === format(new Date(), 'yyyy-MM-dd') ? 'space-between' : 'flex-end', margin: 'auto', alignItems: 'center', marginTop: 30, width: '97%', marginBottom: 5 }}>
                            {
                                data.appointment_status_name === "Cancel" ?
                                    <div></div> :
                                    data.appointment_status_name === "Hold" ?
                                        <div>
                                        </div>
                                        :
                                        data.appointment_date === format(new Date(), 'yyyy-MM-dd') && (
                                            <div style={{ display: 'flex', alignContent: 'space-between', marginTop: -5 }}>
                                                {data.is_emergency !== 1 && (
                                                    <div
                                                        onClick={() => {
                                                            if (data.appointment_status_name === "Book" || data.appointment_status_name === "Reschedule") {
                                                                setOpenAlert(true)
                                                                setMessageAlert("Anda tidak dapat menggunakan fitur pasien emergency, silahkan check in terlebih dahulu!")
                                                                setStatusAlert("warning")
                                                            } else {
                                                                handleEmergency()
                                                            }
                                                        }}
                                                        style={{ height: 32, width: 180, backgroundColor: '#ff5b5b', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Pasien Emergency</Typography>
                                                    </div>
                                                )}
                                                {
                                                    data.appointment_status_name === "Check-In" ?
                                                        null :
                                                        <div style={{ display: 'flex', alignContent: 'space-between' }}>
                                                            <div
                                                                onClick={() => {
                                                                    setVisibleCheckIn(true)
                                                                    setDisableCheckin(true)
                                                                }}
                                                                style={{ marginLeft: 20, height: 32, width: 180, backgroundColor: '#65ae92', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', }} >
                                                                <Typography style={{ color: '#fff', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Check In</Typography>
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    setDisableCheckin(true)
                                                                    setVisibleCheckInReservation(true)
                                                                }}
                                                                style={{ marginLeft: 20, height: 32, width: 180, backgroundColor: '#65ae92', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', }} >
                                                                <Typography style={{ color: '#fff', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Check In & Registrasi</Typography>
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        )
                            }
                            {
                                data.appointment_status_name === "Cancel" ?
                                    null :
                                    <div
                                        onClick={() => handleBatal()}
                                        style={{ height: 32, width: 150, backgroundColor: 'transparent', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', border: '2px solid #909090', textAlign: 'center' }} >
                                        <Typography style={{ color: 'black', fontSize: 15, marginTop: 4, textAlign: 'center', fontWeight: 500 }}>Batal Reservasi</Typography>
                                    </div>
                            }
                        </div>

                    </div>
                    :
                    <div style={{ height: '88vh', overflow: 'auto' }}>
                        <div style={{ marginTop: 20 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                                <Typography style={{ fontWeight: '500', fontSize: 20 }}>Data Reservasi</Typography>
                                {/* <div
                                    onClick={() => setIsReschedule(true)}
                                    style={{ cursor: 'pointer' }}>
                                    <Typography style={{ fontWeight: '500', fontSize: 16, color: '#0066ff' }}>+ Reschedule</Typography>
                                </div> */}
                            </div>
                            {
                                data.appointment_status_name !== "Cancel" ?
                                    <div className="grid grid-2x grid-mobile-none" style={{ padding: '0px 20px 20px 20px', }}>
                                        <div className="column-1">
                                            <div className="">
                                                {isReschedule ?
                                                    <Autocomplete
                                                        style={{ width: '85%' }}
                                                        options={listPaymentOption}
                                                        getOptionLabel={(option) => option.name}
                                                        disableClearable
                                                        getOptionDisabled={(option) =>
                                                            data.payment_option_id === 1 && option.id === 3 ||
                                                            data.payment_option_id === 2 && option.id === 3
                                                            // option.index !== slotWaktu.length - 1 && option.is_available === "Tidak Tersedia"
                                                        }
                                                        id="payment"
                                                        placeholder="pilih opsi pembayaran"
                                                        defaultValue="pilih opsi pembayaran"
                                                        onChange={(event, newInputValue) => {
                                                            setPaymentMethod(newInputValue)
                                                            forceUpdate()
                                                        }}
                                                        value={paymentMethod}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                {...params}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    style: {
                                                                        fontSize: 14,
                                                                    },
                                                                    disableUnderline: true
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                label="Opsi Pembayaran"
                                                            />
                                                        }
                                                    />
                                                    :
                                                    <TextField
                                                        style={{ width: '85%', borderBottom: 'none !important' }}
                                                        id="opsiPembayaran"
                                                        name="opsiPembayaran"
                                                        label="Opsi Pembayaran"
                                                        value={data.payment_option_name}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085'
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                }
                                            </div>
                                            <div className="">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                    <DatePicker
                                                        margin="normal"
                                                        id="validFrom"
                                                        label="Tanggal"
                                                        format="dd MMM yyyy"
                                                        disabled={!isReschedule}
                                                        defaultValue="Pilih tanggal dan waktu"
                                                        value={tanggal}
                                                        onChange={(date) => {
                                                            setTanggal(date)
                                                            setTimeValue(null)
                                                            setVisibleJadwal(false)
                                                            forceUpdate()
                                                        }}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        style={{ width: '85%' }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            {isReschedule ?
                                                <div className="card" style={{ border: 'none' }}>
                                                    <Typography style={{ fontSize: '11px', color: '#a5a5a5', marginTop: timeslot == false ? 10 : 2, textAlign: 'left' }}>Pilih Sesi Periksa</Typography>
                                                    <div style={{ display: 'flex', marginTop: 5, textAlign: 'center' }}>
                                                        {timeslot == false ?
                                                            <div>
                                                                <Typography>Jadwal Tidak Tersedia</Typography>
                                                            </div>
                                                            :
                                                            timeslot.map((el, idx) => {
                                                                // console.log(el);
                                                                // console.log(data);
                                                                return (
                                                                    <div style={{ marginLeft: 20, cursor: 'pointer', width: 152, maxHeight: 30, minHeight: 30, borderRadius: 16, backgroundColor: timeValue === idx || el.detail_time_start === data.time_start ? "#2A9C6C" : 'white', border: timeValue === idx || el.detail_time_start === data.time_start ? '1px solid white' : '1px solid #34b68b', color: timeValue === idx || el.detail_time_start === data.time_start ? "white" : 'black' }}
                                                                        onClick={() => {
                                                                            setTimeValue(idx)
                                                                            // setSelectedId(el.id)
                                                                            setVisibleJadwal(true)
                                                                            setPasienSchedule(null)
                                                                            getDetailTimeSlot(el, idx)
                                                                            handleButton(el)
                                                                            // getTimeSchedule(el)
                                                                            // set_visible_time_schedule(false)
                                                                            forceUpdate()
                                                                        }}
                                                                    >
                                                                        <Typography>{`${el.time_start.slice(0, 5)} - ${el.time_end.slice(0, 5)}`}</Typography>
                                                                    </div>
                                                                )
                                                            })}
                                                    </div>
                                                </div>
                                                :
                                                <div style={{ textAlign: 'left' }}>
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 9 }}
                                                        id="jadwalPeriksa"
                                                        name="jadwalPeriksa"
                                                        label="Jadwal Periksa"
                                                        value={data.patient_schedule}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            }
                                            {detailDokter !== null && (
                                                <div style={{ marginTop: 20 }}>
                                                    <Typography style={{ textAlign: 'left', fontSize: '12px' }}>{detailDokter.is_leave === 1 || detailDokter.is_holiday === 1 ? detailDokter.notes : detailDokter.remarks === null ? '-' : detailDokter.remarks}</Typography>
                                                </div>
                                            )}
                                        </div>
                                        <div className="column-2">
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', cursor: 'pointer', marginTop: 1 }}
                                                    // onClick={() => setVisibleSetListPoli(true)}
                                                    name='Opsi Pembayaran'
                                                    id="payment"
                                                    label="Klinik"
                                                    defaultValue="Pilih Klinik"
                                                    value={`Poliklinik ${data.polyclinic.name}`}
                                                    // onChange={(event, newInputValue) => {
                                                    //     // setPoliklinik(newInputValue)
                                                    // }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', marginTop: 17 }}
                                                    id="namaDokter"
                                                    name="namaDokter"
                                                    label="Nama Dokter"
                                                    value={data.doctor.name}
                                                    onChange={(e) => {
                                                        // handleOnChange(e)
                                                        // setErrorKodeDokter(true)
                                                        // setTextKodeDokter("")
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {visibleJadwal && isReschedule && (
                                                <div className="">
                                                    <Autocomplete
                                                        style={{ width: '85%', marginTop: 8 }}
                                                        options={slotWaktu}
                                                        getOptionLabel={(option) => option.time}
                                                        getOptionDisabled={(option) =>
                                                            option.index !== slotWaktu.length - 1 && option.is_available === "Tidak Tersedia"
                                                        }
                                                        disableClearable
                                                        name='jadwal Periksa'
                                                        id="payment"
                                                        placeholder="pilih jadwal periksa"
                                                        defaultValue="pilih jadwal periksa"
                                                        onChange={(event, newInputValue) => {
                                                            setPasienSchedule(newInputValue)
                                                            setTimeId(newInputValue.id)
                                                        }}
                                                        value={pasienSchedule}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                {...params}
                                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                label="Jadwal Periksa"
                                                            />
                                                        }
                                                    />
                                                </div>
                                            )}
                                            <div>
                                                <TextField
                                                    style={{ width: '100%', marginTop: 10 }}
                                                    disabled={true}
                                                    multiline
                                                    maxRows={2}
                                                    rows={2}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                                        }
                                                    }}
                                                    value={detailDokter !== null ? detailDokter.doctor_notes : ""}
                                                />
                                                {detailDokter && detailDokter.doctor_notes && detailDokter.doctor_notes.length > 20 && (
                                                    <div style={{ width: '85%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setVisibleNotes(true)
                                                        }}
                                                    >
                                                        <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                        <div className="column-1">
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', borderBottom: 'none !important' }}
                                                    id="opsiPembayaran"
                                                    name="opsiPembayaran"
                                                    label="Opsi Pembayaran"
                                                    value={data.payment_option_name}
                                                    onChange={(e) => {
                                                        // handleOnChange(e)
                                                        // setErrorKodeDokter(false)
                                                        // setTextKodeDokter("")
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                    <DatePicker
                                                        margin="normal"
                                                        id="validFrom"
                                                        label="Tanggal"
                                                        format="dd MMM yyyy"
                                                        disabled={!isReschedule}
                                                        defaultValue="Pilih tanggal dan waktu"
                                                        value={data.appointment_date}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        style={{ width: '85%' }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%' }}
                                                    id="jadwalPeriksa"
                                                    name="jadwalPeriksa"
                                                    label="Jadwal Periksa"
                                                    value={data.patient_schedule}
                                                    onChange={(e) => {
                                                        alert('a')
                                                        // handleOnChange(e)
                                                        // setErrorKodeDokter(false)
                                                        // setTextKodeDokter("")
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', marginTop: 15 }}
                                                    id="reservasi"
                                                    name="reservasi"
                                                    label="Reservasi Via"
                                                    value={data.reservation_from || "-"}
                                                    onChange={(e) => {
                                                        // setTextAlamat("")
                                                        // setErrorAlamat(true)
                                                        // handleOnChange(e)
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="column-2">
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', cursor: 'default' }}
                                                    // onClick={() => setVisibleSetListPoli(true)}
                                                    name='Opsi Pembayaran'
                                                    id="payment"
                                                    label="Klinik"
                                                    defaultValue="Pilih Klinik"
                                                    value={`Poliklinik ${data.polyclinic.name}`}
                                                    // onChange={(event, newInputValue) => {
                                                    //     // setPoliklinik(newInputValue)
                                                    // }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', marginTop: 17 }}
                                                    id="namaDokter"
                                                    name="namaDokter"
                                                    label="Nama Dokter"
                                                    value={data.doctor.name}
                                                    onChange={(e) => {
                                                        // handleOnChange(e)
                                                        // setErrorKodeDokter(false)
                                                        // setTextKodeDokter("")
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="">
                                                <TextField
                                                    style={{ width: '85%', marginTop: 17 }}
                                                    id="namaDokter"
                                                    name="namaDokter"
                                                    label="Lokasi Praktek Dokter"
                                                    defaultValue=" "
                                                    value={data.location}
                                                    onChange={(e) => {
                                                        // handleOnChange(e)
                                                        // setErrorKodeDokter(false)
                                                        // setTextKodeDokter("")
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                            }

                        </div>
                        <div>
                            <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550 }}>Kelengkapan Data Pasien</Typography>
                            <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                <div className="column-1">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%' }}
                                            id="idReservasi"
                                            name="idReservasi"
                                            label="ID Reservasi"
                                            value={data.booking_id}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(false)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="queue"
                                            name="queue"
                                            label="No Antrian"
                                            value={data.queue_number}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(true)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="noRekam"
                                            name="noRekam"
                                            label="No Rekam Medis"
                                            value={data.patient.medical_record_no || "-"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(true)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="" style={{ marginTop: -3 }}>
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="jenisKelamin"
                                            name="jenisKelamin"
                                            label="Jenis Kelamin"
                                            value={data.patient.gender === 'L' ? "Laki-Laki" : "Perempuan"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(true)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="noHp"
                                            name="noHp"
                                            label="No. Telepon"
                                            value={data.patient.phone}
                                            // error={errorNoSTR}
                                            // helperText={textNoSTR}
                                            placeholder={"input No hp pasien"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(true)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            label="No. Handphone"
                                            value={data.patient.mobile_phone}
                                            // error={errorNoSTR}
                                            // helperText={textNoSTR}
                                            placeholder={"input No hp pasien"}
                                            onChange={(e) => {
                                                // setErrorNoSTR(true)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="column-2">
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%' }}
                                            id="namaPasien"
                                            name="namaPasien"
                                            label="Nama Pasien"
                                            value={data.patient.name}
                                            onChange={(e) => {
                                                // handleOnChange(e)
                                                // setErrorKodeDokter(true)
                                                // setTextKodeDokter("")
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 15 }}
                                            id="noKtp"
                                            name="noKtp"
                                            label="No KTP"
                                            value={data.patient.identity_no || "-"}
                                            onChange={(e) => {
                                                // setErrorNama(true)
                                                // setTextNama("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />

                                        {/* <Autocomplete
                                        style={{width: '85%', marginTop: 20}}
                                        options={dummyList}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='jenisKelamin'
                                        id="jenisKelamin"
                                        defaultValue="pilih jenis kelamin"
                                        onChange={(event, newInputValue) => {
                                            // setPoliklinik(newInputValue)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Jenis Kelamin"
                                            />
                                        }
                                    /> */}
                                    </div>
                                    <div className="">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                            <DatePicker
                                                margin="normal"
                                                id="bod"
                                                label="Tanggal Lahir"
                                                format="dd MMM yyyy"
                                                defaultValue="Pilih tanggal lahir pasien"
                                                value={new Date(data.patient.date_of_birth)}
                                                // onChange={(date) => {
                                                //     pertanyaanLength.tanggalBerlaku = new Date(date).toLocaleDateString()
                                                // }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputProps={{
                                                    // startAdornment: <InputAdornment style={{  height: '10%', right: 0, position: 'absolute' }}><img src={search} style={{ height: '2vh' }} /></InputAdornment>,
                                                    disableUnderline: true
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                style={{ width: '85%' }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="">
                                        <TextField
                                            style={{ width: '85%', marginTop: 0 }}
                                            id="alamat"
                                            name="alamat"
                                            label="Alamat"
                                            value={data.patient.address || "-"}
                                            onChange={(e) => {
                                                // setTextAlamat("")
                                                // setErrorAlamat(true)
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                        <TextField
                                            style={{ width: '100%', marginTop: 10 }}
                                            id="inputKeluhan"
                                            name="inputKeluhan"
                                            label="Catatan Pasien"
                                            value={data.notes === "" || data.notes === null || data.notes === "null" ? "-" : data.notes}
                                            onChange={(e) => {
                                                // setErrorNoSTR(true)
                                                // setTextNoSTR("")
                                                // handleOnChange(e)
                                            }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                {
                                    data.appointment_status_name === "Cancel" ?
                                        <TextField
                                            label="Alasan Batal"
                                            style={{ width: '100%' }}
                                            value={alasanBatal}
                                            // disabled={true}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                            onChange={(e) => {
                                                setAlasanBatal(e.target.value);
                                                forceUpdate()
                                            }}
                                            InputProps={{
                                                disableUnderline: false
                                            }}
                                        />
                                        : null
                                }
                            </div>
                        </div>
                        {data.appointment_status_name !== "Cancel" && (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>File Pendukung</Typography>
                                </div>
                                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '10px 20px 20px' }}>
                                    <div className="column-1">
                                        <div className="">
                                            <Typography style={{ fontSize: 13, color: '#7e8085', fontWeight: 500 }}>Upload File Medical Check Up / LAB</Typography>
                                            {data.patient.media.length > 0 ?
                                                data.patient.media.map((item) => {
                                                    return (
                                                        <div
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                window.open(item.file_url, "_blank")
                                                            }}>
                                                            <Typography style={{ fontSize: 14, color: 'black' }}>{item.file_name}</Typography>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <Typography style={{ fontSize: 14, color: 'black' }}>-</Typography>
                                            }
                                        </div>
                                        {paymentMethod && paymentMethod.id === 3 ?
                                            <div style={{ textAlign: 'left' }}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        label="Tanggal Rujukan"
                                                        required={noRujukan !== "" || noRujukan === null ? true : false}
                                                        disabled={isReschedule}
                                                        format="dd/MM/yyyy"
                                                        minDate={new Date('01-01-1901')}
                                                        placeholder="Tanggal Rujukan"
                                                        value={dateRujukan}
                                                        onChange={(date) => {
                                                            setDateRujukan(date)
                                                        }}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        style={{ width: '85%', cursor: 'pointer' }}
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            maxlength: 16
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 16,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                                <TextField
                                                    style={{ width: '85%', marginTop: 10 }}
                                                    disabled={isReschedule}
                                                    label="Nama Pasien BPJS"
                                                    placeholder={"Input Nama Pasien BPJS"}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    onChange={(e) => {
                                                        setNamaPasienBPJS(e.target.value)
                                                        forceUpdate()
                                                    }}
                                                    value={namaPasienBPJS}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 16,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />

                                                <TextField
                                                    style={{ width: '85%', marginTop: 10 }}
                                                    disabled={isReschedule}
                                                    label="Nomor SEP"
                                                    placeholder={"Input Nama Nomor SEP"}
                                                    inputProps={{
                                                        maxlength: 19,
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    onChange={(e) => {
                                                        setNoSEP(e.target.value)
                                                        forceUpdate()
                                                    }}
                                                    value={noSEP}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 16,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />
                                                {data.appointment_status_id === 3 ?
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                        <KeyboardDatePicker
                                                            margin="normal"
                                                            label="Jadwal Kontrol"
                                                            disabled={isReschedule}
                                                            placeholder='Jadwal Kontrol'
                                                            format="dd/MM/yyyy"
                                                            minDate={new Date('01-01-1901')}
                                                            value={dateRujukanBalik}
                                                            onChange={(date) => {
                                                                setDateRujukanBalik(date)
                                                            }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            style={{ width: '85%', cursor: 'pointer' }}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                },
                                                                maxlength: 16
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    :
                                                    null
                                                }
                                            </div> :
                                            paymentMethod && paymentMethod.id === 2 ?
                                                <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                    <Autocomplete
                                                        style={{ width: '85%' }}
                                                        options={categoryProvider}
                                                        getOptionLabel={(option) => option.type}
                                                        disabled={isReschedule}
                                                        value={pickCategory}
                                                        onChange={(a, newInputValue) => {
                                                            setLoading(true)
                                                            setPickCategory(newInputValue)
                                                            setProvider(null)
                                                            getProviderByCategory(newInputValue && newInputValue.type)
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                {...params}
                                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                label="Kategori Provider"
                                                            />
                                                        }
                                                    />
                                                    <Autocomplete
                                                        style={{ width: '85%', marginTop: 10 }}
                                                        options={listProvider}
                                                        disabled={isReschedule ? true : pickCategory === null ? true : false}
                                                        getOptionLabel={(option) => option.name}
                                                        debug
                                                        value={provider}
                                                        onChange={(a, newInputValue) => {
                                                            setProvider(newInputValue)
                                                            setPickAsuransi(null)
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                {...params}
                                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                label="Provider"
                                                            />
                                                        }
                                                    />

                                                </div>
                                                : null
                                        }
                                    </div>
                                    <div className="column-2">
                                        {paymentMethod && paymentMethod.id === 3 ?
                                            <div>
                                                <TextField
                                                    style={{ width: '85%', marginTop: -5 }}
                                                    disabled={isReschedule}
                                                    label="No Rujukan"
                                                    placeholder={"Input No Rujukan"}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    value={noRujukan}
                                                    error={errorRujukan}
                                                    helperText={textErrorRujukan}
                                                    onChange={(e) => {
                                                        setNoRujukan(e.target.value)
                                                        setTextErrorRujukan("")
                                                        setErrorRujukan(false)
                                                        forceUpdate()
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 16,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />

                                                <TextField
                                                    style={{ width: '85%', marginTop: 15 }}
                                                    disabled={isReschedule}
                                                    label="No Kartu"
                                                    placeholder={"Input No Kartu BPJS"}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                    }}
                                                    onChange={(e) => {
                                                        setNoKartuBPJS(e.target.value)
                                                        forceUpdate()
                                                    }}
                                                    value={noKartuBPJS}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 16,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />
                                                <Autocomplete
                                                    style={{ width: '85%', marginTop: 20 }}
                                                    options={listKunjungan}
                                                    getOptionLabel={(option) => option.name}
                                                    // debug
                                                    disableClearable={true}
                                                    name='kunjungan'
                                                    id="kunjungan"
                                                    onChange={(a, b) => {
                                                        setKunjungan(b)
                                                        // setErrorGender(false)
                                                        // setMessageErrorGender(null)
                                                        forceUpdate()
                                                    }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            disabled={isReschedule}
                                                            {...params}
                                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                                            label="Jenis Kunjungan"
                                                        // error={errorGender}
                                                        // helperText={messageErrorGender}
                                                        />
                                                    }
                                                    value={kunjungan}
                                                />
                                            </div> :
                                            paymentMethod && paymentMethod.id === 2 ?
                                                <div>
                                                    <TextField
                                                        style={{ width: '85%' }}
                                                        disabled={isReschedule}
                                                        label="No Kartu Peserta Jaminan"
                                                        placeholder={"Input No Kartu Peserta Jaminan"}
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 16,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            setNoKartuAsuransi(e.target.value)
                                                            forceUpdate()
                                                        }}
                                                        value={noKartuAsuransi}
                                                        InputProps={{
                                                            endAdornment:
                                                                <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                                                    {data.patient.medical_record_no && (
                                                                        <div style={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                getListAsuransi(data.patient.medical_record_no, paymentMethod && paymentMethod.id === 2 ? "" : "&without_insurance=1")
                                                                            }}
                                                                        >
                                                                            <img src={ic_search} />
                                                                        </div>
                                                                    )}
                                                                </InputAdornment>,
                                                        }}
                                                    />
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 10 }}
                                                        disabled={isReschedule}
                                                        label="Nama Pemegang Kartu Asuransi"
                                                        placeholder={"Input Nama Pemegang Kartu"}
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        onChange={(e) => {
                                                            setNamaPasienAsuransi(e.target.value)
                                                            forceUpdate()
                                                        }}
                                                        value={namaPasienAsuransi}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 16,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        {
                            data.appointment_status_name !== "Cancel" ?
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => {
                                            setIsReschedule(false)
                                            setVisibleEdit(false)
                                        }}
                                        style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div
                                        onClick={() => disableButton === true ? null : doEdit()}
                                        style={{ height: 32, width: 150, backgroundColor: disableButton ? 'grey' : '#2a9c6c', borderRadius: 20, cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                    </div>
                                </div>
                                :
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => {
                                            setIsReschedule(false)
                                            setVisibleEdit(false)
                                        }}
                                        style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div
                                        onClick={() => disableButton === true ? null : changeStatus()}
                                        style={{ height: 32, width: 150, backgroundColor: disableButton ? 'grey' : '#2a9c6c', borderRadius: 20, cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                    </div>
                                </div>

                        }
                    </div>
            }
            <div>
            </div>

            {
                visibleCatatanPetugas ?
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan Petugas</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setVisibleCatatanPetugas(false)
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ height: '30vh' }}>
                                <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Petugas</Typography>
                                <textarea
                                    label="Catatan Petugas"
                                    value={catatanPetugas}
                                    onChange={(e) => {
                                        setCatatanPetugas(e.target.value)
                                        forceUpdate()
                                    }}
                                    style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                    placeholder={"input catatan petugas"}
                                />
                                <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa dihapus</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                    <div
                                        onClick={() => handleAddNotes()}
                                        style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {
                uploadVisible && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setUploadVisible(false)
                                            setPicture("")
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            {/* {
                            data.appointment_media != false ?
                            <img src={data.appointment_media[0].file_name} />
                            // <div style={{backgroundImage:`url(${data.appointment_media[0].file_name})`, height: 30, width: 30}}>

                            // </div>
                            :
                            null
                        } */}
                            <ImageUploader
                                withIcon={true}
                                withPreview
                                buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                                buttonText={'Select Picture'}
                                onChange={onDrop}
                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                maxFileSize={1000000}
                                label={"Max file size: 1 Mb, accepted: jpg or png"}
                                accept={`${data.appointment_media[0].file_name}`}
                            />
                            {pictures.length > 0 ?
                                <div style={{ display: 'grid', margin: 20 }}>
                                    <div style={{ justifySelf: 'center' }}>
                                        <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                )
            }

            {
                status ?
                    <div className="App app-popup-show">
                        <div style={{ width: '100%', height: '60vh', margin: 'auto', position: 'relative' }}>
                            <img src={bg_notif} style={{ width: '30%', height: '70vh', margin: 'auto' }}></img>
                            <div style={{}}>
                                <img src={circle} style={{ width: 104, height: 104, top: 20, position: 'absolute', margin: 'auto', right: '46%' }} />
                                <img src={ic_checkmark} style={{ width: 41, height: 41, position: 'absolute', top: 50, right: '48.2%' }} />
                            </div>
                            <Typography style={{ top: 130, position: 'absolute', left: '42%', fontSize: 30, color: '#278863' }} >Reservasi Berhasil</Typography>
                        </div>
                        <div style={{ height: '38vh', width: '27vw', position: 'absolute', top: '50%', left: '37%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ color: '#bdc3c7', fontSize: 16, fontFamily: 'poppins' }}>
                                    <Typography style={{ textAlign: 'start' }} >Kode Reservasi</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Poliklinik</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Dokter</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Nama Pasien</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Hari & Waktu</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Catatan Pasien</Typography>
                                </div>
                                <div style={{ marginRight: 55 }}>
                                    <Typography style={{ textAlign: 'start' }} >IDB123</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >THT</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Dr. Albert Leonardo</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Angela Zhakir</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >16 Sep 2020, 13:15 - 13:30</Typography>
                                    <Typography style={{ textAlign: 'start', marginTop: 10 }} >Radang Tenggorokan</Typography>
                                </div>
                            </div>
                            <div
                                onClick={() => setStatus(false)}
                                style={{ height: 30, width: 180, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', margin: 'auto', marginTop: 40, }} >
                                <Typography style={{ color: 'white', fontSize: 18, textAlign: 'center', margin: 'auto' }}>Tutup</Typography>
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                visibleListPoli ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%' }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, backgroundColor: '#278863' }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'white', fontSize: 18, }}>List Poliklinik</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => setVisibleSetListPoli(false)}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div>
                                {
                                    dataPoli && dataPoli.map((el, idx) => {
                                        return (
                                            <div style={{ display: 'block' }}>
                                                <div style={{ display: 'flex', marginTop: 20, borderBottom: '1px solid #ebebeb' }}>
                                                    <img src={el.media_path} style={{ width: 30, height: 30 }} />
                                                    <Typography>{el.name}</Typography>
                                                    <CustomCheckbox
                                                        checked={el.checked}
                                                        onChange={() => handleCheked(idx)}
                                                        style={{ position: 'absolute', right: 0 }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    : null
            }

            {
                visibleEmergency ?
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" />
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => onClose()}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}>Tombol ini hanya untuk pasien keadaan darurat dan harus di tangani lebih dulu, apakah anda yakin? </Typography>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => onClose()}
                                        style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div
                                        onClick={() => submitEmergency()}
                                        style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                visibleCheckIn ?
                    <form onSubmit={(e) => {
                        e.preventDefault()
                        submitCheckIn()
                    }}>
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" />
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>Check In Pasien, Anda Yakin? </Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => submitCheckIn()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    : null
            }
            {
                visibleCheckInReservation ?
                    <form onSubmit={(e) => {
                        e.preventDefault()
                        submitCheckInDanRegis()
                    }}>
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" />
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>Check In dan Registrasi Pasien, Anda Yakin? </Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => submitCheckInDanRegis()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    : null
            }
            {
                visibleBatal ?
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col content-left" style={{ width: 400, alignSelf: 'center', }}>
                                    <Typography>Batal Reservasi</Typography>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => onClose}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <TextField
                                    label="Alasan Batal"
                                    value={alasanBatal}
                                    style={{ width: '90%' }}
                                    placeholder="input alasan batal"
                                    onChange={(e) => {
                                        setAlasanBatal(e.target.value)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => onClose()}
                                        style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div
                                        onClick={() => changeStatus()}
                                        style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {
                error && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            {/* <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            
                        </div> */}
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}>{errorMessage}</Typography>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    {/* <div
                                    onClick={() => setError(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Ok</Typography>
                                </div> */}
                                    <div
                                        onClick={() => setError(false)}
                                        style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                errorForce && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            {/* <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            
                        </div> */}
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}>{errorMessage}</Typography>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    <div
                                        onClick={() => setErrorForce(false)}
                                        style={{ height: 32, width: 150, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => handleForceReschedule()}
                                        style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                errorRequest ?
                    <ErrorRequest
                        message={errorMessageRequest}
                        close={() => {
                            setErrorRequest(false)
                            setVisibleCheckIn(false)
                            setVisibleCheckInReservation(false)
                            setDisableCheckin(false)
                        }}
                    />
                    : null
            }

            {
                visibleNotes && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            <div style={{ padding: 20 }}>
                                <textarea
                                    value={detailDokter.doctor_notes}
                                    disabled
                                    style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                                />
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => setVisibleNotes(false)}
                                        style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                        <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                visibleOpenPendukung && (
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 30, margin: 'auto', overflow: 'auto', width: 1000 }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18, }}>Pilih Jaminan</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => setVisibleOpenPendukung(false)}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ padding: '20px 20px 40px' }}>
                                {/* <Typography style={{ fontWeight: 'bold' }}>PILIH ASURANSI</Typography> */}
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '10%' }} />
                                    <div style={{ width: '20%' }}>
                                        <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>No Kartu</Typography>
                                    </div>
                                    <div style={{ width: '35%' }}>
                                        <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Nama Provider</Typography>
                                    </div>
                                    <div style={{ width: '35%' }}>
                                        <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Nama Pemegang Kartu</Typography>
                                    </div>
                                </div>
                                {arrayAsuransi.length > 0 && arrayAsuransi.map((item, index) => {
                                    return (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 10 }}>
                                            <GreenRadio
                                                checked={false}
                                                onClick={() => {
                                                    setPickAsuransi(item)
                                                    setNoKartuAsuransi(item.insurance_no)
                                                    setNamaPasienAsuransi(item.patient_name)
                                                    setVisibleOpenPendukung(false)
                                                    getProviderByCode(item.provider_code)
                                                    forceUpdate()
                                                }}
                                                // value="c"
                                                name="radio"
                                                style={{ padding: 0, width: '10%' }}
                                                inputProps={{ 'aria-label': 'C' }}
                                            />
                                            <div style={{ width: '20%', alignSelf: 'center' }}>
                                                <Typography style={{ textAlign: 'left' }} >{item.insurance_no}</Typography>
                                            </div>
                                            <div style={{ width: '35%', alignSelf: 'center' }}>
                                                <Typography style={{ textAlign: 'left' }}>{item.insurance_name}</Typography>
                                            </div>
                                            <div style={{ width: '35%', alignSelf: 'center' }}>
                                                <Typography style={{ textAlign: 'left' }}>{item.patient_name}</Typography>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
            }

            {visibleUpload && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleUpload(false)
                                        forceUpdate()
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <UploadFile
                            type={uploadstatus}
                            percentage={percentage}
                            sizeUpload={sizeUpload}
                            result={result}
                            acceptedFiles={["JPG", "JPEG", "PNG", "PDF", "DOC", "DOCX"]}
                            onHandle={(dt) => {
                                fileHandler(dt)
                                setuploadstatus('idle')
                                setpercentage('0')
                            }}
                            docSize={sizeFile}
                            docName={nameFile}
                            onDrop={onDrop}
                            onUpload={() => {
                                // checkPreview()
                                // this.uploadAttachment(this.state.formData)
                            }}

                            onDelete={() => {
                                setNameFile("")
                                setSizeFile("")
                            }}
                        />
                    </div>
                </div>
            )}

            {visibleForceCheckin && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                        <div style={{ margin: 'auto' }}>
                            <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                            </div>
                            <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 18 }}>Warning</Typography>
                        </div>
                        <div>
                            <Typography>{errorMessageRequestCheckin}</Typography>
                        </div>
                        <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>
                            <div onClick={() => setVisibleForceCheckin(false)} style={{ height: 32, width: 150, backgroundColor: 'white', borderRadius: 20, cursor: 'pointer', border: '1px solid #2a9c6c', color: '#2a9c6c' }} >
                                <Typography style={{ color: '#2a9c6c', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                            </div>
                            <div onClick={() => handleForceCheckin()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleForceCheckinRegis && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                        <div style={{ margin: 'auto' }}>
                            <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                            </div>
                            <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 18 }}>Warning</Typography>
                        </div>
                        <div>
                            <Typography>{errorMessageRequestCheckinRegis}</Typography>
                        </div>
                        <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>
                            <div onClick={() => setVisibleForceCheckinRegis(false)} style={{ height: 32, width: 150, backgroundColor: 'white', borderRadius: 20, cursor: 'pointer', border: '1px solid #2a9c6c', color: '#2a9c6c' }} >
                                <Typography style={{ color: '#2a9c6c', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                            </div>
                            <div onClick={() => handleForceCheckinRegis()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleNomorAntrian && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: '#f8fdff', height: '35vh', width: '57vh', display: 'grid' }}>
                        <div style={{ margin: 'auto' }}>
                            <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                            </div>
                        </div>
                        <div>
                            <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 25, color: '#2a9c6c', fontFamily: 'Poppins' }}>Check In Berhasil !</Typography>
                        </div>
                        <div>
                            <Typography style={{ fontSize: 18 }}>Nomor Antrian anda : <b>{displayNoAntrian}</b></Typography>
                        </div>
                        <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>
                            {/* <div onClick={() => setVisibleForceCheckinRegis(false)} style={{ height: 32, width: 150, backgroundColor: 'white', borderRadius: 20, cursor: 'pointer', border: '1px solid #2a9c6c', color: '#2a9c6c' }} >
                      <Typography style={{ color: '#2a9c6c', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                  </div> */}
                            <div onClick={() => handleBack()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleFifoCheckin && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: '#f8fdff', height: '35vh', width: '57vh', display: 'grid' }}>
                        <div style={{ margin: 'auto' }}>
                            <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                            </div>
                        </div>
                        <div>
                            <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 25, color: '#2a9c6c', fontFamily: 'Poppins' }}>Success    </Typography>
                        </div>
                        <div>
                            <Typography style={{ fontSize: 18 }}>Nomor antrian akan didapatkan pada saat check in / kedatangan</Typography>
                        </div>
                        <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>
                            {/* <div onClick={() => setVisibleForceCheckinRegis(false)} style={{ height: 32, width: 150, backgroundColor: 'white', borderRadius: 20, cursor: 'pointer', border: '1px solid #2a9c6c', color: '#2a9c6c' }} >
                      <Typography style={{ color: '#2a9c6c', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                  </div> */}
                            <div onClick={() => {
                                setVisibleFifoCheckin(false)
                                setVisibleEdit(false)
                                setIsReschedule(false)
                            }}
                                style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    )
}